// src/utils/logger.js
// Debug logger — only outputs when REACT_APP_DEBUG=true is set in the environment.
// In production builds without this flag, all calls are no-ops with zero console I/O.

const isDebug = process.env.REACT_APP_DEBUG === 'true';

const logger = {
  log:   (...args) => { if (isDebug) console.log(...args); },
  warn:  (...args) => { if (isDebug) console.warn(...args); },
  error: (...args) => { if (isDebug) console.error(...args); },
  debug: (...args) => { if (isDebug) console.debug(...args); },
};

export default logger;
